import { render } from "./newuseredit.vue?vue&type=template&id=54cb1725"
import script from "./newuseredit.vue?vue&type=script&lang=js"
export * from "./newuseredit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__